// Dynamic Variables taxonomy for WhatsApp Flow Builder
// Matches BenchAdmin collection schemas: Classes, Packages, Products, Members, Gym, Payments, Invoices

export const DYNAMIC_VARIABLE_GROUPS = [
  {
    group: 'Classes',
    icon: 'Calendar',
    badgeColor: 'indigo',
    variables: [
      { label: 'Class Name', value: 'class.class_name', example: 'Morning Yoga Flow' },
      { label: 'Class Date', value: 'class.class_date', example: '30 Oct 2026' },
      { label: 'Class Time / Slot', value: 'class.class_time', example: '07:00 AM - 08:00 AM' },
      { label: 'Trainer Name', value: 'class.trainer_name', example: 'Alex Morgan' },
      { label: 'Studio / Room', value: 'class.room_name', example: 'Studio A (Main Hall)' },
      { label: 'Class Capacity', value: 'class.capacity', example: '25' },
    ],
  },
  {
    group: 'Packages',
    icon: 'Package',
    badgeColor: 'teal',
    variables: [
      { label: 'Package Name', value: 'package.package_name', example: 'Gold Annual Membership' },
      { label: 'Package Price', value: 'package.package_price', example: '₹14,999' },
      { label: 'Duration', value: 'package.duration', example: '12 Months' },
      { label: 'Validity Period', value: 'package.validity', example: '365 Days' },
      { label: 'Sessions Count', value: 'package.session_count', example: 'Unlimited' },
      { label: 'Package Description', value: 'package.description', example: 'Full access to gym, spa, and all fitness classes' },
      { label: 'Payment Type', value: 'package.payment_type', example: 'One-time Payment' },
    ],
  },
  {
    group: 'Products',
    icon: 'ShoppingBag',
    badgeColor: 'violet',
    variables: [
      { label: 'Product Name', value: 'product.product_name', example: 'Optimum Whey Protein 1kg' },
      { label: 'Product Price', value: 'product.price', example: '₹3,499' },
      { label: 'Product Category', value: 'product.category', example: 'Supplements' },
      { label: 'Product SKU', value: 'product.sku', example: 'SUP-WHEY-101' },
      { label: 'Product Description', value: 'product.description', example: '100% Whey Protein Isolate with rich chocolate flavour' },
    ],
  },
  {
    group: 'Branch',
    icon: 'MapPin',
    badgeColor: 'cyan',
    variables: [
      { label: 'Branch Name', value: 'branch.name', example: 'Indiranagar Main' },
      { label: 'Branch Address', value: 'branch.address', example: '100 Feet Rd, Indiranagar' },
      { label: 'Branch City', value: 'branch.city', example: 'Bangalore' },
      { label: 'Branch Phone', value: 'branch.phone', example: '+919876543210' },
      { label: 'Branch ID', value: 'branch.id', example: 'br_90823' },
    ],
  },
  {
    group: 'Member',
    icon: 'User',
    badgeColor: 'emerald',
    variables: [
      { label: 'First Name', value: 'member.first_name', example: 'Rahul' },
      { label: 'Last Name', value: 'member.last_name', example: 'Sharma' },
      { label: 'Mobile Number', value: 'member.mobile_number', example: '+919876543210' },
      { label: 'Email', value: 'member.email', example: 'rahul.sharma@example.com' },
      { label: 'Branch Name', value: 'member.branch_name', example: 'Downtown Branch' },
      { label: 'Current Package', value: 'member.current_pkg_name', example: 'Gold Annual Plan' },
      { label: 'Package Price', value: 'member.current_pkg_price', example: '₹14,999' },
      { label: 'Subscription Start Date', value: 'member.subscription_start_date', example: '01 Nov 2026' },
      { label: 'Subscription End Date', value: 'member.subscription_end_date', example: '31 Oct 2027' },
      { label: 'City', value: 'member.address.city', example: 'Bangalore' },
    ],
  },
  {
    group: 'Gym Info',
    icon: 'Building',
    badgeColor: 'amber',
    variables: [
      { label: 'Gym Name', value: 'gym.name', example: 'Bench Fitness Club' },
      { label: 'Gym Mobile', value: 'gym.mobile_number', example: '+918001234567' },
      { label: 'Gym Email', value: 'gym.email', example: 'support@benchfitness.com' },
      { label: 'Gym City', value: 'gym.city', example: 'Bangalore' },
      { label: 'Gym Address', value: 'gym.address_1', example: '100 Feet Road, Indiranagar' },
    ],
  },
  {
    group: 'Payment & Invoice',
    icon: 'CreditCard',
    badgeColor: 'blue',
    variables: [
      { label: 'Amount Paid', value: 'payment.amount', example: '₹14,999' },
      { label: 'Payment Mode', value: 'payment.payment_mode', example: 'UPI' },
      { label: 'Transaction ID', value: 'payment.order_id', example: 'TXN-90823145' },
      { label: 'Payment Status', value: 'payment.status', example: 'Successful' },
      { label: 'Invoice ID', value: 'invoice.invoice_id', example: 'INV-2026-0045' },
      { label: 'Invoice Date', value: 'invoice.invoice_date', example: '29 Oct 2026' },
      { label: 'Due Date', value: 'invoice.due_date', example: '05 Nov 2026' },
      { label: 'Balance Due', value: 'invoice.balance_due', example: '₹0' },
    ],
  },
  {
    group: 'System',
    icon: 'Cpu',
    badgeColor: 'rose',
    variables: [
      { label: 'Payment Link (Full URL)', value: 'system.payLink', example: 'https://pay.benchfitness.com/l/98234' },
      { label: 'Payment Link (Short)', value: 'system.payLinkPath', example: '/pay/98234' },
      { label: 'Days Left / Remaining', value: 'system.days_left', example: '5' },
      { label: 'OTP Code', value: 'system.otp', example: '4928' },
    ],
  },
];

// Flat list of all available dynamic variables
export const ALL_DYNAMIC_VARIABLES = DYNAMIC_VARIABLE_GROUPS.flatMap((g) =>
  g.variables.map((v) => ({ ...v, group: g.group }))
);

// Helper to retrieve up to 10 list items based on source, branch filter, and live Firestore data
export const getDynamicListItems = (source = 'packages', customItems = [], liveCollections = {}, branchId = null) => {
  if (source === 'custom') {
    return Array.isArray(customItems) ? customItems.slice(0, 10) : [];
  }
  if (source === 'branches') {
    return Array.isArray(liveCollections?.branches) ? liveCollections.branches.slice(0, 10) : [];
  }
  if (source === 'packages') {
    const list = Array.isArray(liveCollections?.packages) ? liveCollections.packages : [];
    if (branchId && branchId !== 'all') {
      const filtered = list.filter(p => !p.branch_id || p.branch_id === branchId || p.branch_id === 'all');
      return (filtered.length > 0 ? filtered : list).slice(0, 10);
    }
    return list.slice(0, 10);
  }
  if (source === 'classes') {
    const list = Array.isArray(liveCollections?.classes) ? liveCollections.classes : [];
    if (branchId && branchId !== 'all') {
      const filtered = list.filter(c => {
        if (!c.branch_ids || c.branch_ids.length === 0) return true;
        return c.branch_ids.includes(branchId);
      });
      return (filtered.length > 0 ? filtered : list).slice(0, 10);
    }
    return list.slice(0, 10);
  }
  if (source === 'products') {
    const list = Array.isArray(liveCollections?.products) ? liveCollections.products : [];
    if (branchId && branchId !== 'all') {
      const filtered = list.filter(p => !p.branch_id || p.branch_id === branchId || p.branch_id === 'all');
      return (filtered.length > 0 ? filtered : list).slice(0, 10);
    }
    return list.slice(0, 10);
  }
  return [];
};

// Helper to replace {{class.class_name}}, {{package.package_name}}, etc. with real session or contact values
export const resolveDynamicVariables = (text = '', customValues = {}) => {
  if (!text) return '';
  return text.replace(/\{\{\s*([a-zA-Z0-9_.-]+)\s*\}\}/g, (match, key) => {
    if (customValues && customValues[key] !== undefined && customValues[key] !== null) {
      return String(customValues[key]);
    }
    // Keep placeholder variable intact if not yet provided by user session
    return match;
  });
};

